import { Component, OnInit } from '@angular/core';
import {IDialogView} from "@shared/components/ok-cancel-dialog/ok-cancel-dialog.component";
import {DialogModel} from "@shared/models/dialog.model";

@Component({
    standalone: false,
    selector: 'app-note-dialog-editor',
  templateUrl: './note-dialog-editor.component.html',
  styleUrls: ['./note-dialog-editor.component.scss']
})
export class NoteDialogEditorComponent implements OnInit, IDialogView {
  data: DialogModel;
  item: any;
  key: any;

  detailText: any;

  constructor() { }

  ngOnInit(): void {
    this.item = this.data.input['item'];
    this.key = this.data.input['key'];
    const key = this.key ;
    this.detailText = this.item.cells[key].displayText;
  }


  onOkClicked(): any {
  }

}
